import React from 'react';
import { useSelector } from 'react-redux';

const Loader = () => {
  const loading = useSelector(state => state.app.loading);

  return (
    <div>
      {loading && (
        <div className="loader-overlay">
          <div className="loader" />
        </div>
      )}
    </div>
  );
};

export default Loader;
